import React from 'react';
import classNames from 'classnames';
import copyProps from '../utils/copy-props';
import VstComponent from './VstComponent';

export default class VstTab extends VstComponent {
  constructor() {
    super();
    this.tabTo = this.tabTo.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.active && this.props.active) {
      this.tab.focus();
    }
  }

  // I added this so routing in mulligan didn't have to change much, but ideally tabs wouldn't change the url
  tabTo() {
    const { href, onClick } = this.props;
    if (href) { window.location.assign(href); }
    onClick();
  }

  onKeyDown(e) {
    if (e.keyCode === 37 || e.keyCode === 38) {
      this.props.onPreviousTab();
    } else if (e.keyCode === 39 || e.keyCode === 40) {
      this.props.onNextTab();
    }
  }

  render() {
    return (
      <li role="presentation" {...copyProps(this.props, ['active', 'onClick', 'href', 'onPreviousTab', 'onNextTab'])} className={classNames('vst-tab', { active: this.props.active })}>
        <a
          aria-selected={this.props.active}
          onClick={this.tabTo} className="vst-link"
          ref={tab => { this.tab = tab; }}
          role="tab"
          tabIndex={this.props.active ? 0 : -1}
          onKeyDown={this.onKeyDown}
        >
          {this.props.children}
        </a>
      </li>
    );
  }

}
